/* ================================================== */
/* IMAGESLOADED → Init
/* ================================================== */

$(document).ready(function(){

	function loadImages($src) {
		$src.imagesLoaded().progress(function(instance, image) {
			$('img[src="' + image.img.src + '"]').addClass('loaded');
		});
	}

	var imagesContainers = ['.article--webpage'];
	$.each(imagesContainers, function(index, value) {
		loadImages($(value));
	});

});